<template>
  <div class="container-fluid mt-4 SlimTDs">
    <b-row>
      <b-col>
        <span :class="`size-${ButtonSize}`">Ürünler</span>
      </b-col>

      <b-col class="text-right mb-3 top-buttons">
        <b-btn class="m-1" type="button" variant="danger" to="/" :size="ButtonSize">
          <i class="material-icons mifix">arrow_back</i>
          <span class="ml-1" v-if="ScreenWidth >= 340">Ana Ekran</span>
        </b-btn>

        <b-btn to="/Products/Add" class="btn-info m-1" :size="ButtonSize">
          <i class="material-icons mifix">add</i>
          <span class="ml-1">Ürün Ekle</span>
        </b-btn>
      </b-col>
    </b-row>

    <b-table
      striped
      hover
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :items="Products"
      :fields="fields"
      responsive
    >
      <template v-slot:cell(Category)="data">
        <div class="ws-nowrap">{{ data.item.Category }}</div>
      </template>

      <template v-slot:cell(Kitchen)="data">
        <div class="ws-nowrap">{{ data.item.Kitchen }}</div>
      </template>

      <template v-slot:cell(Name)="data">
        <div class="ws-nowrap">{{ data.item.Name }}</div>
      </template>

      <template v-slot:cell(Price)="data">
        <div class="ws-nowrap">{{ data.item.Price }}</div>
      </template>

      <template v-slot:cell(Actions)="data">
        <b-btn size="sm" :to="`/Products/${data.item.ID}`" class="mr-2">Düzenle</b-btn>
      </template>
    </b-table>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      sortBy: "Kategori Adı",
      sortDesc: false,
      fields: [
        { key: "Category", label: "Kategori Adı", sortable: true },
        { key: "Kitchen", label: "Mutfak", sortable: true },
        { key: "Name", label: "Ürün Adı", sortable: true },
        { key: "MinPortion", label: "Min. Porsiyon", sortable: true },
        { key: "Portions", label: "Artış Miktarı", sortable: true },
        { key: "Price", label: "Fiyat", sortable: true },
        { key: "Sort", label: "Sıralama", sortable: true },
        { key: "Actions", label: "İşlem", sortable: false }
      ]
    };
  },
  computed: {
    ...mapState(["StoreData", "ScreenWidth", "ButtonSize"]),
    Categories() {
      return this.StoreData.Categories ? this.StoreData.Categories : {};
    },
    Products() {
      let _Products = [];

      if (this.StoreData.Products) {
        for (let i in this.StoreData.Products) {
          const _Product = this.StoreData.Products[i];

          _Products.push({
            ID: _Product.ID,
            Category: this.StoreData.Categories[_Product.CategoryID].Name,
            Kitchen: this.StoreData.Kitchens[_Product.KitchenID].Name,
            Name: _Product.Name,
            MinPortion: _Product.MinPortion,
            Portions: _Product.Portions,
            Price: _Product.Price.Money(),
            Sort: _Product.Sort,
            Status: _Product.Status ? "Aktif" : "Pasif"
          });
        }
      }

      return _Products;
    }
  },
  mounted() {
    this.$store.subscribe(async () => {
      await this.$nextTick();
      await this.$forceUpdate();
    });
  }
};
</script>
